import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import { IPatrocinadorCupom } from "../../interface/IPatrocinadorCupom";
import { useMoeda } from "../../../core/hooks/useMoeda";

interface PatrocinadoresCupomModalProps {
    open: boolean;
    onClose: () => void;
    patrocinadores: IPatrocinadorCupom[];
}

export const PatrocinadoresCupomModal = ({ open, onClose, patrocinadores }: PatrocinadoresCupomModalProps) => {
    const { real } = useMoeda();

    return (
        <Dialog 
            open={open} 
            onClose={onClose} 
            maxWidth="md" 
            fullWidth
            sx={{
                zIndex: 10000,
            }}
            PaperProps={{
                sx: {
                    zIndex: 10000,
                },
            }}
        >
            <DialogTitle>Patrocinadores do Cupom</DialogTitle>
            <DialogContent>
                <TableContainer component={Paper} variant="outlined" sx={{ mt: 2 }}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell align="left">Descrição</TableCell>
                                <TableCell align="left">Valor</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {patrocinadores && patrocinadores.length > 0 ? (
                                patrocinadores.map((patrocinador, index) => (
                                    <TableRow key={index}>
                                        <TableCell align="left">
                                            {patrocinador.descricao || patrocinador.nome || "-"}
                                        </TableCell>
                                        <TableCell align="left">
                                            {patrocinador.valor !== undefined ? real(patrocinador.valor) : "-"}
                                        </TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={2} align="center">
                                        Nenhum patrocinador encontrado
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="contained">
                    Fechar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

